export default "__VITE_ASSET__2cd2a4a3__"